import { getNoun } from '../../../utils/getNoun';

export const getTextForCounterBanner = (amount: number, maxAmount: number, isMobile: boolean): string => {
  if (isMobile) {
    const verb = amount === 1 ? 'Выбран' : 'Выбрано';

    return `${verb} ${amount} из ${maxAmount}`;
  }
  if (amount === 0) {
    return 'Не выбрано ни одного риелтора';
  } else if (amount === maxAmount) {
    return 'Вы можете отправить заявку выбранным риелторам';
  } else {
    const pluralNouns = ['риелтор', ' риелтора', 'риелторов'];
    const verb = amount === 1 ? 'Выбран' : 'Выбрано';
    const noun = getNoun(amount, pluralNouns);

    return `${verb} ${amount} ${noun} из ${maxAmount}`;
  }
};
